module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Ruddy_Gore2#Contents-A"
    }
  }, [_vm._v("Author Note")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("Please note that all Chinese names in this book are derived from the sixteenth-century classic Outlaws of the Marsh. The 1928 cast of Ruddigore did not include any murderers. No identification with any persons alive or dead is intended or should be inferred.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5db633bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ruddy_Gore-6.vue
// module id = 75
// module chunks = 0